export const GRAY_FRAME = '#696969';
export const BUTTON_COLOR = 'color: #1a1a1a; background-color: #F8F9FA; border-color: #DADCE0';
